import { useMemo } from "react";
import { searchInlines } from "utils/helpers";

const useGetFilteredRows = ({
  rowsData,
  searchValue,
  sortingData,
  tableHeaders,
}) => {
  const rowsDataFilteredBySearch = useMemo(() => {
    return searchInlines(rowsData, searchValue);
  }, [rowsData, searchValue]);
  const rowsDataFilteredBySort = useMemo(() => {
    if (rowsDataFilteredBySearch) {
      let sortingName = null;

      for (let key in sortingData) {
        if (sortingData[key].isActive) {
          sortingName = key;
        }
      }

      let sortedRows = rowsDataFilteredBySearch;

      if (sortingName) {
        const linesIndex = tableHeaders?.findIndex(
          (item) => item === sortingName
        );
        const lineRow = rowsDataFilteredBySearch.find((row) => {
          if (row.lines[linesIndex] || row.lines[linesIndex] === 0) {
            return true;
          }
        });
        const line = lineRow?.lines[linesIndex];
        let sortingType = "";

        if (typeof line === "number") sortingType = "number";
        if (typeof line === "string") sortingType = "string";

        sortedRows = rowsDataFilteredBySearch.sort((a, b) => {
          if (sortingType === "string") {
            if (sortingData[sortingName].isDescending) {
              return b?.lines[linesIndex]?.localeCompare(a?.lines[linesIndex]);
            }
            return a?.lines[linesIndex]?.localeCompare(b?.lines[linesIndex]);
          } else if (sortingType === "number") {
            if (sortingData[sortingName].isDescending) {
              return (
                Number(b?.lines[linesIndex]) - Number(a?.lines[linesIndex])
              );
            }
            return (
              Number(a?.lines[linesIndex]) - Number(b?.lines[linesIndex])
            );
          } else {
            return a;
          }
        });
      }

      return sortedRows;
    }
  }, [rowsDataFilteredBySearch, sortingData, tableHeaders]);

  return {rowsDataFilteredBySort, rowsDataFilteredBySearch};
};

export default useGetFilteredRows;
